/* eslint-disable no-return-assign */
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from 'react';
import '../../styles/home.scss';
import { Grid, Link, Button, Divider, Stack } from '@mui/material';
import HeaderSection from '../header-section';
import { ro } from '../../shared/assets/images';

function Home() {
  const [selected, setSeleted] = useState('2');

  const handleClick = (value) => {
    setSeleted(value);
  };
  const { innerHeight } = window;

  return (
    <div style={{ height: innerHeight }}>
      <div style={{ backgroundColor: '#FFF', height: '0px' }} />
      <div style={{ backgroundColor: '#F2F2F2', height: innerHeight - 15 }}>
        <HeaderSection />
        <div style={{ backgroundColor: 'white', overflow: 'hidden' }} >
          <Grid container spacing={1} style={{ marginTop: '0.1%', height: innerHeight - 160, alignItems: 'center' }}>
            <Grid item xs={6} style={{ marginBottom: '5%' }}>
              <Grid item xs={12} className="winflows-text rufusBld">
                Winflows Design Simulator
              </Grid>
              <Grid item xs={12} className="membrane sansW4SeLig">
                Membrane system design software
              </Grid>
              <Grid container spacing={1} className="sansW4SeLig">
                <Stack
                  direction="row"
                  divider={<Divider sx={{ background: '#00AEC7', height: '19px', width: '1px' }} orientation="vertical" flexItem />}
                  spacing={3}
                  className="item-stack1">
                  <span>Accurate</span>
                  <span>Chemical Pretreatment</span>
                  <span>Depth Filtration Media</span>
                </Stack>
                <Stack
                  direction="row"
                  divider={<Divider style={{ background: '#00AEC7', height: '19px', width: '1px' }} orientation="vertical" flexItem />}
                  spacing={3}
                  className="item-stack2">
                  <span>Increased Efficiency</span>
                  <span>Comprehensive</span>
                  <span>Post Treatment</span>
                </Stack>
              </Grid>
              <Grid item xs={12} className="showmore">
                <Link href="#" variant="body2" underline="none" className="sansW4SeLig">
                  {' '}
                  Show more
                </Link>
              </Grid>
              <Grid item xs={12} className="signin-link ">
                <Button variant="contained"
                  onClick={() => window.location.href = '/sign-in'} data-testid="login-button"
                  style={{ backgroundColor: '#00AEC7', width: '279px', textTransform: 'none' }} className="sansW6SeBld ">
                  Sign In
                </Button>
              </Grid>
            </Grid>
            <Grid item xs={6} style={{ paddingTop: '33px', paddingBottom: '19px' }}>
              <img align="right" src={ro} style={{ marginRight: '12%', width: '70%' }} alt="rosystem" />
            </Grid>
          </Grid>

          <Grid
            container
            spacing={1}
            className="home-footer rufusReg" style={{ width: '100%', margin: '0px', height: '100px' }}>
            <Grid item xs={3}
              className={selected === '1' ? 'selected bottom-div' : 'bottom-div'}
              onClick={() => handleClick('1')}>
              <div style={{ margin: '6px', fontSize: '18px' }} className="selected-body">
                {' '}
                Easy way to create your own preffered Water Treatment System
              </div>
            </Grid>
            <Grid item xs={3}
              className={selected === '2' ? 'selected bottom-div' : 'bottom-div'}
              onClick={() => handleClick('2')}>
              <div className="selected-tile">Step 1 </div>
              <div className="selected-body">Sign in to Winflows Design Simulator</div>
            </Grid>
            <Grid
              item
              xs={3}
              className={selected === '3' ? 'selected bottom-div' : 'bottom-div'}
              onClick={() => handleClick('3')}>
              <div className="selected-tile">Step 2 </div>
              <div className="selected-body">Create your own Water Treatment System</div>
            </Grid>
            <Grid
              item
              xs={3}
              className={selected === '4' ? 'selected bottom-div' : 'bottom-div'}
              onClick={() => handleClick('4')}>
              <div className="selected-tile">Step 3 </div>
              <div className="selected-body">Buy and Setup your Water Treatment System</div>
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
  );
}
export default Home;
